<template lang="pug">
  transition(name="model")
    .modal-mask(@mousedown="close")
      .modal-wrapper
        .modal-container.modal-0
          .inform.mb-2
            .inform__header
              .close(@click="close") ×
            div(v-if="type === 'delete'")
              .inform__warning
              h2.text-center Are you sure?
              p.text-center.lead.fontt-weight-normal You won't be able to revert this!
              .inform__message(v-if="inform_message")
                ul.pl-0
                  li.text-center(v-for="item, key in inform_message")
                    span.font-weight-normal(v-if="Number(key) === 0 && Number(item) > 0") Good
                      | : {{ item }}
                    span.font-weight-normal(v-if="Number(key) === 2 && Number(item) > 0") Attention
                      | : {{ item }}
                    span.font-weight-normal(v-if="Number(key) === 1 && Number(item) > 0") Bad
                      | : {{ item }}
              .inform__btns.d-flex.justify-content-center
                button.active.btn.btn-primary.mr-2(@click="send_action") Yes, delete it!
                button.active.btn.btn-secondary.mr-2.inform_cancel(@click="close") Cancel
            div(v-if="type === 'inform'")
              h2.text-center Are you sure?
              p.text-center.lead.fontt-weight-normal {{ inform_message }}
              .inform__btns.d-flex.justify-content-center
                button.active.btn.btn-primary.mr-2(@click="send_action") Yes!
                button.active.btn.btn-secondary.mr-2.inform_cancel(@click="close") Cancel
</template>
<script>
  export default {
    data() {
      return {
        type: null,
        action: null,
        action_data: null,
        inform_message: null,
      };
    },
    computed: {
      inform_data() {
        return this.$store.state.users.modal_inform;
      },
    },
    created() {
      this.type = this.inform_data.type;
      this.action = this.inform_data.action;
      this.action_data = this.inform_data.action_data;
      this.inform_message = this.inform_data.inform_message;
    },
    methods: {
      send_action() {
        this.$store.dispatch(this.action, this.action_data);

        this.$store.commit('set_modal_inform', null);
      },
      close(event) {
        if (['close', 'inform_cancel'].some(
          (e) => event.target.classList.contains(e)) || !event.target.closest('.modal-container')
        ) {
          this.$store.commit('set_modal_inform', null);
        }
      },
    },
  };
</script>
<style lang="stylus">
.inform
  max-width 512px
  width 100%
  background-color white
  padding 1.25em
  transition all 0.3s ease
  display flex
  flex-direction column
  justify-content center
  align-items initial

  .inform__warning
    position relative
    width 2.5em
    height 2.5em
    margin 0 auto
    margin-bottom 10px

    &:after
      width 100%
      height 100%
      top 0
      left 0
      position absolute
      content '!'
      display flex
      justify-content center
      align-items center
      color #f8bb86
      border 3px solid #f8bb86
      border-radius 50%
      font-size 1.75em
      line-height 1.75em
      font-weight 600
</style>
